export default {
  methods: {
    transformUnit(count) {
      let formattedText = '';
      switch (true) {
        case count < 9999:
          if (count < 999) {
            formattedText = count;
          } else {
            formattedText = Number(count).toLocaleString('th-TH');
          }
          break;
        case count >= 9999 && count < 999999:
          if ((Math.floor(count / 1000)).toString().length > 3) {
            formattedText = `${(count / 1000)}K`;
          } else {
            formattedText = `${(count / 1000).toFixed(1)}K`;
          }
          break;
        case count >= 999999 && count < 999999999:
          if ((Math.floor(count / 100000000)).toString().length > 3) {
            formattedText = `${(count / 10000000)}M`;
          } else {
            formattedText = `${(count / 10000000).toFixed(1)}M`;
          }
          break;
        case count >= 999999999:
          if ((Math.floor(count / 1000000000)).toString().length > 3) {
            formattedText = `${(count / 1000000000)}B`;
          } else {
            formattedText = `${(count / 1000000000).toFixed(1)}B`;
          }
          break;
        default:
          formattedText = '0';
          break;
      }
      return formattedText;
    },
    transformBitToMbit(bit) {
      return (bit / 1000000).toFixed(2);
    },
    transformMbitToBit(Mbit) {
      return (Mbit * 1000000).toFixed(2);
    },
    transformMillisecToSec(millisec) {
      return (millisec / 1000).toFixed(2);
    },
  },
};
